import {
  DslRender,
  FormFieldWidget,
  FormM2MTableFieldWidget,
  ModelFieldType,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import PaperProductsStraightShops from './PaperProductsStraightShops.vue';
import { quicklyAdd,orderPreview } from './services';
import {
  orderPreviewAudit,
  orderPreviewCreate
} from "@/custom-widget/MindMap/widgets/field/form/TradeOrderItemDetail/services";
import {cloneDeep, omit} from "lodash-es";
import {iterateObjDeep} from "@/custom-widget/MindMap/utils/object";
import {calcKarNum} from "@/custom-widget/MindMap/utils/productPackage";
import {generateRandomNumber} from "@/custom-widget/MindMap/widgets/field/form/MindMap/utils";
// import {orderPreview} from "@/custom-widget/MindMap/widgets/field/form/PaperProductsStraight/services";

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget: 'Table',
    name: 'pcItemDetail',
    model: ['deli.aries.seller.DeliAriesSellerPaperOrder'],
    multi: true
  })
)
export class PaperProductsStraight extends FormM2MTableFieldWidget {
  public initialize(props: any) {
    super.initialize(props);

    this.setComponent(PaperProductsStraightShops);
    return this;
  }

  @Widget.Method()
  async orderPreview(dataSource: any[]) {
    iterateObjDeep(dataSource, (obj: Record<any, any>) => {
      delete obj.__draftId;
      delete obj._X_ROW_KEY;
      delete obj.META_BIT;
      delete obj._d_model;
    });
    const resData = await orderPreview(this.rModel, { formData : dataSource}, false);
    
    this.dataSource = resData?.pcItemDetail || [];
    return resData;
  }
  @Widget.Method()
  protected renderActionVNodes() {
    // 从dsl中获取actionBar，actionBar里面包含了界面设计器配置的动作
    const formWidgetItem = this.metadataRuntimeContext.viewDsl?.widgets
      .find((w) => w.slot === 'form')
      ?.widgets.find((w) => w.title === '商品明细')
      ?.widgets.find((w) => w.name === 'pcItemDetail')
      ?.widgets.find((w) => w.type === 'TABLE');
    const tableActiveBar = formWidgetItem?.widgets.find((w) => w.slot === 'actionBar');
    if (tableActiveBar) {
      // actionBar.widgets 就是界面设计器配置的动作，借助平台提供的DslRender.render方法，将对应的dsl转换成VNode
      return tableActiveBar.widgets.map((w, index) =>
        DslRender.render({
          ...w,
          __index: index
        })
      );
    }

    return null;
  }
  @Widget.Reactive()
  get rModel() {
    return this.model;
  }

  @Widget.Method()
  async quicklyAddApi(data: { code: string; orderNum: number }) {
    try {
      const code = (this.formData["salesOrganization"] as any).code;
      const res = await quicklyAdd(this.rModel, {
        code: data.code,
        orderNum: data.orderNum,
        salesOrganizationCode: code,
        relationApplyId: (this.formData['relationApply'] as any).id,
        buyerPartnerId: (this.formData['targetPartner'] as any).id
      });
    } catch (error) {}
  }
}
